<script>
  import rules from '@/helpers/validation-rules';
  import YellowButton from '@/components/base/YellowButton.vue';

  export default {
    name: 'BuyInLimitation',

    components: { YellowButton },

    data: () => ({
      rules,
      items: ['24h', '7d', '30d'],

      limitations: [50, 100, 200, 500],

      period: null,
      limitationIndex: null,
    }),

    computed: {
      isConfirmDisabled() {
        return this.limitationIndex == null || !this.period;
      },
    },

    methods: {
      openConfirmDialog() {
        if (!this.$refs.form.validate()) {
          return;
        }

        this.$store.dispatch('showConfirmDialog', {
          title: 'Please Confirm',
          text: `Decrease ${this.period} Buy limit to $${this.limitations[this.limitationIndex]}?`,
          callback: () => {
            setTimeout(() => {
              this.$store.dispatch('showConfirmDialog', {
                title: 'Your Buy Limit has been updated',
                text: `Your new ${this.period} Buy limit has been decreased to $${
                  this.limitations[this.limitationIndex]
                }`,
                yesText: 'Okay',
                noVisible: false,
                callback: () => {
                  // handle confirm
                },
              });
            }, 200);
          },
        });
      },
    },
  };
</script>

<template>
  <v-form lazy-validation ref="form">
    <v-select
      v-model="period"
      solo
      placeholder="Select time period"
      class="black-input w-full mt-10"
      :menu-props="{
        dark: true,
        offsetY: true,
        contentClass: `menu-container`,
      }"
      :items="items"
    />

    <v-chip-group v-model="limitationIndex" class="mt-3">
      <v-chip v-for="limit in limitations" :key="limit">${{ limit }}</v-chip>
    </v-chip-group>

    <div class="text-center text-title black--text mt-4 mb-5">Or add custom value</div>

    <v-text-field solo class="black-input" placeholder="Custom Amount" />

    <div class="text-center mt-5">
      <YellowButton :disabled="isConfirmDisabled" @click="openConfirmDialog" class="confirm-button">
        Confirm
      </YellowButton>
    </div>

    <div class="text-title text-center mt-5">
      For more information check our
      <a href="/responsible-gaming" class="gold--text">Responsible Social Gaming Policy</a>
    </div>
  </v-form>
</template>

<style scoped lang="scss">
  .confirm-button {
    width: 100%;
    min-height: 48px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 800;

    @media screen and (min-width: 768px) {
      width: auto;
      padding-inline: 32px;
    }
  }
</style>
